/** @jsx jsx */
/** @jsxFrag */
import React, { type FC } from 'react';
import { css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { LoadableAfterPaint } from '@confluence/loadable';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';
import { useIsNav4Enabled } from '@confluence/nav4-enabled/entry-points/useIsNav4Enabled.ts';

import { ContainerSkeleton } from './ContainerSkeleton.tsx';
import { SPACE_NAVIGATION_METRIC } from './perf.config.ts';
import type { SpaceNavigationProps } from './SpaceNavigation.tsx';

const separatorStyles = css({
	marginBlock: token('space.0'),
	marginInline: token('space.negative.150'),
	border: '0',
	borderBottom: `${token('border.width')} solid ${token('color.border')}`,
});

export const SpaceNavigationLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceNavigation" */ './SpaceNavigation.tsx'))
			.SpaceNavigation,
	loading: () => <ContainerSkeleton loader />,
});

export const SpaceNavigation: FC<SpaceNavigationProps> = (props) => {
	const isNav4Enabled = useIsNav4Enabled();

	return (
		<>
			{isNav4Enabled && (
				<hr role="presentation" css={separatorStyles} id="space-header-top-divider" />
			)}
			<PageSegmentLoadStart metric={SPACE_NAVIGATION_METRIC} />
			<SpaceNavigationLoader {...props} />
		</>
	);
};

export const SpaceNavigationLoadingSkeleton: FC = () => <ContainerSkeleton loader />;
